/* eslint-disable import/no-unresolved */
import { useMutation, useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CREATE_CLASSIFY_AUDIT_LOGS_FOR_FR2052A } from 'Apollo/Mutations/Rules/FR2052A';
import { tenantIdVar } from 'Apollo/config';
import ClassifyResultModal from '../../common/ClassifyResultModal';

const FR2052AClassifyResult = ({
    setShowClassifyResult, refetch, refetchTestData,
}) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [comment, setComment] = useState('');
    const [radio, setRadio] = useState('MARK_AS_REVIEW_REQUIRED');
    const [showLoader, setShowLoader] = useState(false);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo mutation to update the comment */
    const [updateComment] = useMutation(
        CREATE_CLASSIFY_AUDIT_LOGS_FOR_FR2052A,
        {
            variables: {
                input: {
                    comment,
                    batchId: Number(batchId),
                    eventName: radio,
                    ruleId: Number(ruleId),
                    tenantId: Number(tenantId),
                },
            },
        },
    );

    /* Calls updateComment(), refetches the failed test and audit logs data  */
    const onClickFR2052AClassify = async () => {
        setShowLoader(true);
        await updateComment();
        setComment('');
        setShowLoader(false);
        refetch();
        refetchTestData();
        setShowClassifyResult(false);
    };

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <ClassifyResultModal
            onClickClassify={onClickFR2052AClassify}
            showLoader={showLoader}
            comment={comment}
            setComment={setComment}
            radio={radio}
            setRadio={setRadio}
            setShowClassifyResult={setShowClassifyResult}
        />
    );
};

export default FR2052AClassifyResult;
